import React, { useEffect, useLayoutEffect } from 'react';
import { useAppSelector } from '../../store';
import { useLocalStorage } from 'usehooks-ts';
import { useDispatch } from 'react-redux';
import { setChildrenGroup, setGroupHash, setMainGroup } from '../../store/apps/userSlice';
import { ENUM_LOCALSTORAGE, TEST_MODE } from '../../enums/enums';
import { mockChildrenGroup, mockChildrenGroup10, mockMainGroup } from '../../enums/mock';

export default function useFillStoreByLcs() {
  const [groupHashLcs, setGroupHashLcs] = useLocalStorage(ENUM_LOCALSTORAGE.groupHash);
  const dispatch = useDispatch();
  const groupHash = useAppSelector((state) => state.user.group.hash);

  useLayoutEffect(() => {
    setGroupHashLcs(groupHash);
  }, [groupHash]);

  useLayoutEffect(() => {
    if (groupHashLcs) dispatch(setGroupHash(groupHashLcs));

    // const children = {};
    // if (!groupHashLcs) return;
    // Object.values(groupHashLcs).forEach((group) => {
    //   const parentId = group.parentId || 'root';
    //   if (!children[parentId]) children[parentId] = [];
    //   children[parentId].push(group);
    // });

    // dispatch(setChildrenGroup(children));
  }, []);

  useEffect(() => {
    if (!TEST_MODE) return;
    dispatch(setChildrenGroup({ 1: mockChildrenGroup, 10: mockChildrenGroup10 }));
    dispatch(setMainGroup(mockMainGroup));
    return;
  }, []);
}
